<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="mb-3">
        {{ I18n.t("employees.auctions_catalogs.internet_bids_count", { count: formatPrice(bidsMeta.total_count) }) }}
      </h3>
      <div class="employee__filtration">
        <BidsPagination
          :meta="bidsMeta"
          :auctionId="auction.id"
        />
      </div>
    </div>
    <table class="dashboard__table w-100">
      <BidsTableHead />
      <BidsTableBody
        :auction="auction"
        :key="bidsMeta.current_page"
      />
    </table>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { formatNumber } from '@/shared/helpers';
  import BidsPagination from './../bids_pagination';
  import BidsTableHead from './bids_table_head';
  import BidsTableBody from './bids_table_body';

  export default {
    name: 'BidsTable',
    components: {
      BidsPagination,
      BidsTableHead,
      BidsTableBody,
    },
    props: {
      auction: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    computed: {
      ...mapState(['bidsMeta']),
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/table/bids_table.vue?326ebe27